import React, { useRef, useEffect, useState } from 'react';
import { Form, Input, Button, message, Select } from 'antd';
import { layout, tailLayout } from './constant';
import ApiServices from '~services';

const { Option } = Select;

const AreaForm = ({ fields, isNew, id, reload, onChange, setLoading }) => {
  const inputRef = useRef(null);
  const [companies, setCompanies] = useState([]);

  const getDataInit = async () => {
    const [getCompany] = await Promise.all([ApiServices.getCompanies()]);
    setCompanies(getCompany?.data?.data || []);
  };

  useEffect(() => {
    getDataInit();
  }, []);

  const onCompareWithApi = (value, cb) => {
    if (inputRef.current) {
      clearTimeout(inputRef.current);
      cb();
    }
    inputRef.current = setTimeout(async () => {
      try {
        const { data } = await ApiServices.existsCodeArea(null, value);
        const isUsed = data;
        cb(isUsed);
      } catch (error) {
        console.error(error);
      }
    }, 1000);
  };

  const checkExistsCode = async (_, value) => {
    if (value.length > 2) {
      const ind = fields.findIndex((item) => {
        return item.name[0] === 'code';
      });
      if (isNew === false && value !== fields[ind].value) {
        try {
          const waitMe = () =>
            new Promise((resolve, reject) => {
              onCompareWithApi(value, (isUsed) => {
                if (typeof isUsed !== 'undefined') {
                  if (isUsed) reject();
                  resolve();
                }
              });
            });
          await waitMe();
        } catch (error) {
          return Promise.reject(new Error('Mã Khu Vực này đã tạo rồi !!!'));
        }
      }

      if (isNew === true) {
        try {
          const waitMe = () =>
            new Promise((resolve, reject) => {
              onCompareWithApi(value, (isUsed) => {
                if (typeof isUsed !== 'undefined') {
                  if (isUsed) reject();
                  resolve();
                }
              });
            });
          await waitMe();
        } catch (error) {
          return Promise.reject(new Error('Mã Khu Vực này đã tạo rồi !!!'));
        }
      }
    }
  };

  const createArea = async (data) => {
    try {
      const res = await ApiServices.createArea(data);
      if (res.data) {
        message.success('Tạo mới Khu Vực thành công');
        return reload();
      } else {
        message.error('Tạo mới Khu Vực thất baị, vui lòng kiểm tra lại thông tin');
      }
    } catch (err) {
      message.error('Tạo mới Khu Vực thất baị, vui lòng kiểm tra lại thông tin');
      console.error(err);
    }
  };
  const updateArea = async (data) => {
    data.id = id;
    try {
      const res = await ApiServices.updateArea(id, data);
      if (res.data) {
        message.success('Cập nhật Khu Vực thành công');
        return reload();
      } else {
        message.error('Cập nhật Khu Vực thất baị, vui lòng kiểm tra lại thông tin');
      }
    } catch (err) {
      message.error('Cập nhật Khu Vực thất baị, vui lòng kiểm tra lại thông tin');
      console.error(err);
    }
  };
  const onSubmitForm = async (value) => {
    if (isNew) {
      setLoading(true);
      await createArea(value);
      setLoading(false);
      return;
    }
    setLoading(true);
    await updateArea(value);
    setLoading(false);
  };
  return (
    <Form
      {...layout}
      name='global_state'
      onFinish={onSubmitForm}
      fields={fields}
      onFieldsChange={(_, allFields) => {
        onChange(allFields);
      }}
    >
      <Form.Item
        // {...itemLayout}
        style={{ marginTop: '10px' }}
        name='code'
        label='Mã Khu Vực'
        rules={[
          {
            required: true,
            message: 'Bạn phải nhập Mã Khu Vực',
          },
          {
            validator: checkExistsCode,
          },
          {
            type: 'string',
            min: 3,
            message: 'Bạn phải nhập ít nhất 3 ký tự',
          },
        ]}
      >
        <Input placeholder='Mã Khu Vực' />
      </Form.Item>

      <Form.Item
        style={{ marginTop: '10px' }}
        name='name'
        label='Tên Khu Vực'
        rules={[
          {
            required: true,
            message: 'Bạn phải nhập Tên Khu Vực',
          },
        ]}
      >
        <Input placeholder='Tên Khu Vực' />
      </Form.Item>
      <Form.Item
        name='companyId'
        label='Công Ty'
        rules={[
          {
            required: true,
            message: 'Bạn phải chọn Công Ty',
          },
        ]}
      >
        <Select showSearch placeholder='Lựa Chọn Công Ty'>
          {companies.map(({ id, name }) => (
            <Option key={id} value={id}>
              {name}
            </Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item {...tailLayout}>
        <Button type='primary' htmlType='submit'>
          {isNew ? 'Tạo Mới' : 'Cập nhật'}
        </Button>
      </Form.Item>
    </Form>
  );
};

export { AreaForm };
